/*
    generate by magix-combine@3.6.4: https://github.com/thx/magix-combine
    author: kooboy_li@163.com
    loader: webpack
 */

Magix.addView("app/views/searchheader/index",require("app/views/searchheader/index"));;
Magix.addView("app/views/textlinks/index",require("app/views/textlinks/index"));;
Magix.addView("app/views/optionfilter/index",require("app/views/optionfilter/index"));;
Magix.addView("app/views/itemcollections/index",require("app/views/itemcollections/index"));;
Magix.addView("app/views/pagination/index",require("app/views/pagination/index"));;
Magix.addView("app/views/hotsellitem/index",require("app/views/hotsellitem/index"));;
Magix.addView("app/views/backtop/index",require("app/views/backtop/index"));;

// 用来处理异步加载时的路径寻找问题，如果不需要异步可以删除
~function () {
    var js = document.scripts;
    var url = js[js.length - 1].src;
    var urlScript = url.split('/');
    urlScript.pop();
    urlScript.pop();
    __webpack_public_path__ = urlScript.join('/') + '/';
}();

// KISSY.config({
//     // 开启自动 combo 模式
//     combine:true});

KISSY.use('node,event,ajax', function () {

    Magix.config({
        rootId: 'body1240' // 容器id
        //   defaultView: 'app/tbbody'
    });
    // 开始初始化
    Magix.boot();
});

KISSY.ready(function () {
    var version = parseInt(KISSY.UA.ie, 10);
    var S = KISSY;
    window._SEARCHKEYWORDS = window.root.url.keyword || '连衣裙'; //S.one('#_SEARCHKEYWORDS').val();
    function ajustScreen() {
        var width = getBrowserWidth();
        if (width >= 1350) {
            S.one('body').attr('id', 'body1350');
        } else if (width < 1349 && width >= 1190) {
            S.one('body').attr('id', 'body1190');
        } else {
            S.one('body').attr('id', 'body-normal');
        }
    }
    function getBrowserWidth() {
        if (window.innerWidth) {
            return window.innerWidth;
        } else if (document.documentElement && document.documentElement.clientWidth != 0) {
            return document.documentElement.clientWidth;
        } else if (document.body) {
            return document.body.clientWidth;
        }
        return 0;
    }
    if (version && version <= 8) {
        ajustScreen();
        S.one(window).on('resize', function () {
            ajustScreen();
        });
    }
});


//////////////////
// WEBPACK FOOTER
// ./app/pages/tmsearch/index.js
// module id = 13
// module chunks = 1